import React from "react";
import { useApp } from "@/context/AppContext";
import { Navigate, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import EventForm from "@/components/EventForm";
import { Link } from "react-router-dom";

export default function CreateEvent() {
  const { user, t, refreshMe, checkingAuth } = useApp();
  const nav = useNavigate();
  if (checkingAuth) return null;
  if (!user) return <Navigate to="/auth" />;
  const submit = async (payload, draft = false) => {
    if (user.role === "user") { await api.post("/auth/become-organizer"); await refreshMe(); }
    await api.post("/events", payload, { params: { submit: !draft } });
    toast.success(draft ? t("draftSaved") : t("submittedToast"));
    nav("/dashboard");
  };
  return (
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-8">
      <h1 className="font-display uppercase text-4xl md:text-5xl tracking-tighter border-b border-foreground pb-3">{t("createEvent")}</h1>
      <p className="mt-3 text-sm text-muted-foreground">{t("guidelinesHint")} <Link to="/guidelines" className="underline" data-testid="create-guidelines-link">{t("guidelines")} →</Link></p>
      <EventForm onSubmit={submit} submitLabel={t("submitForReview")} draftLabel={t("saveDraft")} />
    </div>
  );
}
